import React, { Component } from "react";
import { connect } from "react-redux";

import TabsHeader from "../../common/layout/tab/tabsHeader";
import FormCrashSignal from "./Form/FormCrashSignal";
import FormCrashPrompt from "./Form/FormCrashPrompt";
import CrashResults from "./Form/CrashResults";
import CrashLog from "./Form/CrashLog";
import BotOrchestrators from "./Form/BotOrchestrators";

/**
 * Tela do Crash: cronograma, prompts, resultados e a atividade dos bots.
 *
 * O motor de aposta não vive mais aqui. Ele roda no projeto autoblaze_seed, em
 * máquina separada, e conversa com a API — a Blaze bloqueia o acesso ao DOM do
 * jogo por iframe, que era como a versão antiga apostava a partir do navegador.
 */
class Crash extends Component {
  /** Perfil Bot: vê Sinais/Resultados/Bots; Orquestradores só Admin. */
  isBotProfile = () => {
    const noun = this.props.profile && this.props.profile.noun;
    return String(noun || "").toLowerCase() === "bot";
  };

  isAdminProfile = () => {
    const noun = this.props.profile && this.props.profile.noun;
    return String(noun || "").toLowerCase() === "administrador";
  };

  /** Abas visíveis conforme o perfil em sessão. */
  tabs = () => {
    const scopes = this.props.scopes || {};
    const isBot = this.isBotProfile();
    const isAdmin = this.isAdminProfile();

    return [
      {
        id: "signals",
        label: "Sinais",
        render: () => <FormCrashSignal readOnly={isBot} />,
        show: true,
      },
      {
        id: "prompts",
        label: "Prompts",
        render: () => <FormCrashPrompt />,
        show: !isBot && !!scopes.crash_prompts,
      },
      { id: "results", label: "Resultados", render: () => <CrashResults />, show: true },
      {
        id: "bots",
        label: "Bots",
        show: !!scopes.crash_bets,
        render: () => <CrashLog selfOnly={isBot} />,
      },
      {
        id: "orchestrators",
        label: "Orquestradores",
        render: () => <BotOrchestrators />,
        show: isAdmin && !!scopes.bot_orchestrators,
      },
    ].filter((tab) => tab.show);
  };

  render() {
    const tabs = this.tabs();

    return (
      <div className='card card-primary'>
        <TabsHeader>
          {tabs.map((tab, index) => (
            <li className='nav-item' key={tab.id}>
              <a className={`nav-link ${index === 0 ? "active" : ""}`} data-toggle='tab' href={`#crash-tab-${tab.id}`}>
                {tab.label}
              </a>
            </li>
          ))}
        </TabsHeader>
        <div className='card-body'>
          <div className='tab-content'>
            {tabs.map((tab, index) => (
              <div
                className={`tab-pane container ${index === 0 ? "active" : "fade"}`}
                id={`crash-tab-${tab.id}`}
                key={tab.id}
              >
                {tab.render()}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  scopes: (state.auth.profile && state.auth.profile.scopes) || {},
  profile: state.auth.profile,
});
export default connect(mapStateToProps)(Crash);
